import STEPS from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepConstants';

/**
 * Get current step configuration
 */
export const selectCurrentStep = (state) => {
  return STEPS[state.currentStep] || null;
};

/**
 * Determine next step key based on current step and answers
 */
export const selectNextStep = (state, currentStep) => {
  if (!currentStep || currentStep.next === null) return null;

  if (typeof currentStep.next === 'function') {
    return currentStep.next(state.answers);
  }

  return currentStep.next;
};

/**
 * Validate if user can continue to next step
 */
export const selectCanContinue = (state, currentStep) => {
  if (!currentStep) return false;

  switch (currentStep.type) {
    case 'intro':
      return true;

    case 'yesNo':
      return state.answers[currentStep.field] !== undefined;

    case 'foodService':
      return (
        state.answers[currentStep.field] !== undefined &&
        state.answers.variableWeight !== undefined
      );

    case 'input':
      const inputValue = state.answers[currentStep.field];
      return inputValue !== undefined && inputValue !== null && inputValue > 0;

    case 'recommendation':
      return true;

    case 'contactSales':
      return false; // Terminal step

    case 'success':
      return false; // Terminal step

    default:
      return true;
  }
};

/**
 * Get product count
 */
export const selectProductCount = (state) => {
  if (state.products.length > 0) {
    return state.products.length;
  }
  return state.answers.productCount || 0;
};

export const selectRecommendationReason = (state) => {
  const reasons = [];
  const { answers } = state;

  if (answers.alcoholicBeverages) {
    const subItems = [];
    if (answers.beer) subItems.push('Beer');
    if (answers.wine) subItems.push('Wine');
    if (answers.spirits) subItems.push('Spirits');
    reasons.push({ label: 'Alcoholic Beverages', subItems });
  }

  if (answers.foodServiceBulkItems) {
    reasons.push('Foodservice or Bulk');
  }

  if (answers.sellableInnerPack) {
    reasons.push('Innerpack Retailer Sellable');
  }

  if (answers.shelfDisplayBoxTray) {
    reasons.push('Product Merchandized in Tray');
  }

  if (answers.displayShippers) {
    reasons.push('Store Displays or Shippers');
  }

  if (answers.perishable) {
    reasons.push('Perishable Items');
  }

  if (answers.multipacks) {
    reasons.push('Multipack Items');
  }

  if (answers.productCount > 15) {
    reasons.push(
      `You are submitting ${answers.productCount} product(s) (more than 15)`
    );
  } else {
    reasons.push(
      `You are submitting ${answers.productCount} product(s) (less than or equal 15)`
    );
  }

  return reasons;
};
